var map = {
	"./Ahmedabad.png": "2SbB",
	"./Delhi NCR.png": "1SNC",
	"./Hyderabad.png": "Aob7",
	"./Jaipur.png": "KYTg",
	"./Kolkata.png": "drh8",
	"./Mumbai.png": "4sxp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OiCb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city ^\.\/.*\.png$
// module id = OiCb
// module chunks = 11